import React, { useRef } from "react";
import { useLockFn } from "ahooks";
import { YhForm } from "@components/YhFormBox";
import { YHDrawer } from "@src/components/YhDrawer";
import { globalPrompt } from "@src/components/YhMessage";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { rosterDetailsModels } from "./rosterDetailsModels";
import { rosterService } from "../../rosterService";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";

export const SalaryAdjustDrawer: React.FC<{
  visible: boolean;
  userInfo: any;
  onCancel: () => void;
}> = ({ visible, userInfo, onCancel }) => {

  const { user } = useGlobalModel()
  const {
    loadDs, getDetail, getFormInfo,
    salary, salarys,
  } = rosterDetailsModels();

  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 12 },
    disabled: false,
    initialValues: { ...salary, adjustmentDate: null, staffId: userInfo.staffId, name: userInfo.name },
    justify: "start",
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "员工工号",
        fieldName: "staffId",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        disable: true,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "员工姓名",
        fieldName: "name",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
        disable: true,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "基本工资",
        fieldName: "baseSalary",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "岗位补贴",
        fieldName: "positionAllowance",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "技能补贴",
        fieldName: "skillAllowance",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "调薪时间",
        fieldName: "adjustmentDate",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
      {
        type: FormItemTypeEnum.TextArea,
        fieldLabel: "调薪原因",
        fieldName: "adjustmentReason",
        span: 12,
        rules: [{ required: true, message: "该项为必选项" }],
      },
    ],
  };

  const onAdjust = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      const salarysData = [...salarys, {
        ...formData,
        operator: user.userName,
        bankName: salary.bankName,
        bankAccountNumber: salary.bankAccountNumber,
        skillLevel: salary.skillLevel,
        outstandingEmployee: salary.outstandingEmployee,
        salaryType: salary.salaryType,
      }];
      if (formData) {
        const params = {
          employeeId: userInfo.id,
          userSalaryRecordsList: salarysData?.map((item: any) => ({
            ...item,
            adjustmentDate: item.adjustmentDate ? moment(item.adjustmentDate).format("YYYY-MM-DD HH:mm:ss") : undefined,
          }))
        };
        const ret = await rosterService.salaryInsert(params);
        if (ret.success) {
          await globalPrompt("message", { type: "success", text: "调薪成功!" });
          onCancel();
        } else {
          await globalPrompt("message", { type: "error", text: "调薪失败!" + ret.retMsg });
        }
      }
    } catch (e) {
      console.log("调薪失败!");
    }
  });

  return (
    <YHDrawer
      {...{
        title: "薪资调整",
        visible,
        onOk: () => { onAdjust() },
        onCancel,
        width: 680,
        showFooter: true,
        okText: "确定",
        cancelText: "关闭",
      }}
    >
      <YhForm {...formConfig} />
    </YHDrawer>
  );
};